import { render, staticRenderFns } from "./table-wrapper.vue?vue&type=template&id=30216dac&scoped=true&"
import script from "./table-wrapper.vue?vue&type=script&lang=ts&"
export * from "./table-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./table-wrapper.vue?vue&type=style&index=0&id=30216dac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30216dac",
  null
  
)

export default component.exports